import { clsx, type ClassValue } from "clsx"
import { TFunction } from 'i18next';
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const parseUserAgent = (userAgent: string, t: TFunction) => {
  if (!userAgent) return t('userSettings.activeSessions.unknownDevice');
  const ua = userAgent.toLowerCase();

  const hasAppLibraries = /(okhttp|alamofire|dart|cfnetwork)/i.test(ua);
  const isAndroidWebView = /android.*wv/.test(ua);
  const isIosWebView = /(iphone|ipad|ipod).*applewebkit(?!.*safari)/.test(ua);

  if (hasAppLibraries) return t('userSettings.activeSessions.app');
  if (isAndroidWebView) return t('userSettings.activeSessions.androidWebView');
  if (isIosWebView) return t('userSettings.activeSessions.iosWebView');
  
  // Browser detection
  if (userAgent.includes('Edg/')) return 'Microsoft Edge';
  if (userAgent.includes('Chrome/') && !userAgent.includes('Edg/')) return 'Google Chrome';
  if (userAgent.includes('Firefox/')) return 'Mozilla Firefox';
  if (userAgent.includes('Safari/') && !userAgent.includes('Chrome/')) return 'Safari';
  if (userAgent.includes('Opera/')) return 'Opera';
  
  // Mobile detection
  if (userAgent.includes('iPhone')) return 'iPhone Safari';
  if (userAgent.includes('iPad')) return 'iPad Safari';
  if (userAgent.includes('Android')) return 'Android Browser';
  if (userAgent.includes('Mobile')) return 'Mobile Browser';
  
  return 'Desktop Browser';
};